<template>
  <div class="tradContainer">
    <!-- 头部 -->
    <div class="tradHeader">
      <!-- 市场价格 -->
      <div class="tradeMaket">
        <!-- 全国、地区 -->
        <div class="tradeCenter">
          <div class="centerleft">
            <ul>
              <li
                :class="{ active: item.name === curLocation }"
                @click="getMarketLocation(item)"
                v-for="(item, index) in centerCity"
                :key="index"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="centerright">
            {{ marketObj.currDate }} {{ marketObj.currTime }}
          </div>
        </div>
        <div class="tradeData">
          <div class="maketleft">
            <!-- 配额 -->
            <div class="mktop">
              <div class="mk1">
                <!-- <div class="mk1img">
                  <img src="../../assets/kanban.png" alt="" />
                  <span>配额</span>
                </div> -->

                <div class="mk1title">
                  <div
                    class="mk1down"
                    :class="{
                      mkdefault:
                        !marketObj.latestPrice ||
                        marketObj.latestPrice === '0.00' ||
                        parseFloat(marketObj.latestPrice) ===
                          parseFloat(marketObj.lastPrice),
                      mkgreen:
                        parseFloat(marketObj.latestPrice) <
                        parseFloat(marketObj.lastPrice),
                      mkred:
                        parseFloat(marketObj.latestPrice) >
                        parseFloat(marketObj.lastPrice),
                    }"
                  >
                    <span>{{ "配额" + toptitle + ":" }} </span>
                    <b>{{
                      !marketObj.latestPrice || marketObj.latestPrice === "0.00"
                        ? "--"
                        : marketObj.latestPrice
                    }}</b>
                  </div>
                </div>
              </div>
              <div class="mkdemo">
                <div class="uptxt">
                  <span>涨幅:</span>
                  <b
                    :class="{
                      green: parseFloat(marketObj.increase) < 0,
                      red: parseFloat(marketObj.increase) > 0,
                      default:
                        !marketObj.increase || marketObj.increase === '0.00%',
                    }"
                    >{{
                      !marketObj.increase ||
                      (marketObj.increase === "0.00%" &&
                        parseFloat(marketObj.latestPrice) !==
                          parseFloat(marketObj.lastPrice))
                        ? "--"
                        : marketObj.increase
                    }}</b
                  >
                </div>
                <div class="downtxt">
                  <span>涨跌:</span>
                  <b
                    :class="{
                      green: parseFloat(marketObj.riseFall) < 0,
                      red: parseFloat(marketObj.riseFall) > 0,
                      default:
                        !marketObj.riseFall || marketObj.riseFall === '0.00',
                    }"
                    >{{
                      !marketObj.riseFall ||
                      (marketObj.riseFall === "0.00" &&
                        parseFloat(marketObj.latestPrice) !==
                          parseFloat(marketObj.lastPrice))
                        ? "--"
                        : marketObj.riseFall
                    }}</b
                  >
                </div>
              </div>
              <!-- <div class="mkxian"></div> -->
              <div class="mkdemo">
                <div class="uptxt">
                  <span>开盘:</span>
                  <b
                    :class="{
                      green:
                        parseFloat(marketObj.openPrice) <
                        parseFloat(marketObj.lastPrice),
                      red:
                        parseFloat(marketObj.openPrice) >
                        parseFloat(marketObj.lastPrice),
                      default:
                        !marketObj.openPrice ||
                        marketObj.openPrice === '0.00' ||
                        parseFloat(marketObj.openPrice) ===
                          parseFloat(marketObj.lastPrice),
                    }"
                    >{{
                      !marketObj.openPrice || marketObj.openPrice === "0.00"
                        ? "--"
                        : marketObj.openPrice
                    }}</b
                  >
                </div>
                <div class="downtxt">
                  <span>昨收:</span>
                  <b>{{ marketObj.lastPrice ? marketObj.lastPrice : "--" }}</b>
                </div>
              </div>
              <!-- <div class="mkxian"></div> -->
              <div class="mkdemo mksan">
                <div class="uptxt">
                  <span>最高:</span>
                  <b
                    :class="{
                      green:
                        parseFloat(marketObj.highLimit) <
                        parseFloat(marketObj.lastPrice),
                      red:
                        parseFloat(marketObj.highLimit) >
                        parseFloat(marketObj.lastPrice),
                      default:
                        marketObj.highLimit === '0.00' ||
                        parseFloat(marketObj.highLimit) ===
                          parseFloat(marketObj.lastPrice),
                    }"
                    >{{
                      marketObj.highLimit === "0.00" || !marketObj.highLimit
                        ? "--"
                        : marketObj.highLimit
                    }}</b
                  >
                </div>
                <div class="downtxt">
                  <span>最低:</span>
                  <b
                    :class="{
                      green:
                        parseFloat(marketObj.lowLimit) <
                        parseFloat(marketObj.lastPrice),
                      red:
                        parseFloat(marketObj.lowLimit) >
                        parseFloat(marketObj.lastPrice),
                      default:
                        marketObj.lowLimit === '0.00' ||
                        parseFloat(marketObj.lowLimit) ===
                          parseFloat(marketObj.lastPrice),
                    }"
                    >{{
                      marketObj.lowLimit === "0.00" || !marketObj.lowLimit
                        ? "--"
                        : marketObj.lowLimit
                    }}</b
                  >
                </div>
              </div>
              <!-- <div class="mkxian"></div> -->
              <div class="mkdemo mkliang mktopsan">
                <div class="uptxt">
                  <span>挂牌成交量:</span>
                  <b
                    >{{
                      marketObj.totalNum && marketObj.totalNum !== "--"
                        ? marketObj.totalNum
                        : "--"
                    }} </b
                  ><strong>吨</strong>
                </div>
                <div class="downtxt">
                  <span>挂牌成交额:</span>
                  <b
                    >{{
                      marketObj.totalAmount && marketObj.totalAmount !== "--"
                        ? formatToMillionths(marketObj.totalAmount)
                        : "--"
                    }} </b
                  ><strong>万元</strong>
                </div>
              </div>
            </div>
            <!-- <div class="mkheng"></div> -->

            <!-- CCER -->
            <div class="mkbottom">
              <div class="mk1">
                <!-- <div class="mk1img">
                  <img src="../../assets/kanban2.png" alt="" />
                </div> -->

                <div class="mk1title">
                  <div class="mk1down mkdefault">
                    <span>CCER均价: </span>
                    <b>{{ ccerObj.averagePrice }}</b>
                  </div>
                </div>
              </div>
              <div class="mkdemo mkliang">
                <div class="uptxt upbotom">
                  <span>最新成交量:</span>
                  <b>{{ addThousandsSeparator(parseInt(ccerObj.totalNum)) }} </b
                  ><strong>吨</strong>
                </div>
              </div>
              <div class="mkdemo mkliang">
                <div class="downtxt">
                  <span>最新成交额:</span>
                  <b
                    >{{
                      addThousandsSeparator(
                        parseFloat(ccerObj.totalAmount / 10000).toFixed(2)
                      )
                    }} </b
                  ><strong>万元</strong>
                </div>
              </div>
            </div>

            <!-- 绿证 -->
            <div class="mkbottom">
              <div class="mk1">
                <!-- <div class="mk1img">
                  <img src="../../assets/kanban2.png" alt="" />
                </div> -->

                <div class="mk1title">
                  <div class="mk1down mkdefault">
                    <span>绿证均价: </span>
                    <b>{{ lvzhengObj.averagePrice }}</b>
                  </div>
                </div>
              </div>

              <div class="mkdemo mkliang">
                <div class="uptxt upbotom">
                  <span>最新成交量:</span>
                  <b v-if="lvzhengObj.totalNum"
                    >{{ addThousandsSeparator(parseInt(lvzhengObj.totalNum)) }}
                  </b>
                  <b v-else>--</b>
                  <strong>个</strong>
                </div>
              </div>

              <div class="mkdemo mkliang">
                <div class="downtxt">
                  <span>最新成交额:</span>
                  <b v-if="lvzhengObj.totalAmount"
                    >{{
                      parseInt(lvzhengObj.totalAmount) > 10000
                        ? addThousandsSeparator(
                            parseInt(lvzhengObj.totalAmount / 10000)
                          )
                        : addThousandsSeparator(
                            parseInt(lvzhengObj.totalAmount)
                          )
                    }}
                  </b>
                  <b v-else>--</b>
                  <strong>{{
                    parseInt(lvzhengObj.totalAmount) > 10000 ? "万元" : "元"
                  }}</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="mksrong">
            <!-- <div class="srtop">数据截止时间：</div>
          <div class="srbotom">
            {{ marketObj.currDate }} {{ marketObj.currTime }}
          </div> -->
            <div class="srtop green" @click="handeInBuy(1)">
              <svg-icon icon-class="icbuy" />我要买
            </div>
            <div class="srbotom blue" @click="handeInBuy(2)">
              <svg-icon icon-class="ic_sale" />我要卖
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 拍卖详情 -->
    <action></action>
    <!-- 求购大厅/售卖大厅 -->
    <div class="tradBox">
      <div class="box">
        <div class="boxheader boxqiugou">
          <h3>
            <img src="../../assets/buy02.png" alt="" /><span>求购大厅</span>
          </h3>
          <div class="trit" @click="handInBuyList(1)" style="line-height: 60px">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
            <!-- <svg-icon icon-class="trademorehover" /> -->
          </div>
        </div>

        <div class="boxtit">
          <div class="pname">求购产品</div>
          <div class="pnumber">求购数量</div>
          <div class="price">单价(元)</div>
          <div class="name">公司名称</div>
        </div>
        <div class="xian"></div>
        <div
          class="boxtit boxdata"
          v-for="(item, index) in buydata"
          :key="index"
          @click="handInBuyDetail(item, 1)"
        >
          <div class="pname">{{ item.productName }}</div>
          <div class="pnumber">
            <span style="font-family: sans-serif; font-weight: 600">{{
              addThousandsSeparator(item.circulatingQuantity)
            }}</span>
            <i style="color: #83879b; font-size: 14px">
              {{ item.productType === 6 ? "个" : "吨" }}</i
            >
          </div>
          <div class="price">
            ¥<span style="font-family: sans-serif; font-weight: 600">{{
              item.listingPrice
            }}</span>
          </div>
          <div class="name">{{ item.contactCompanyName }}</div>

          <!-- <div class="creat" @click="handInBuyDetail(item, 1)">查看</div> -->
        </div>
      </div>
      <div class="box">
        <div class="boxheader boxshoumai">
          <h3><img src="../../assets/sale02.png" alt="" />售卖大厅</h3>
          <div class="trit" @click="handInBuyList(2)" style="line-height: 60px">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div>

        <div class="boxtit">
          <div class="pname">售卖产品</div>
          <div class="pnumber">售卖数量</div>
          <div class="price">单价(元)</div>
          <div class="name">公司名称</div>
        </div>
        <div class="xian"></div>
        <div
          class="boxtit boxdata"
          v-for="(item, index) in saledata"
          :key="index"
          @click="handInBuyDetail(item, 2)"
        >
          <div class="pname">{{ item.productName }}</div>
          <div class="pnumber">
            <span style="font-family: sans-serif; font-weight: 600">{{
              addThousandsSeparator(item.circulatingQuantity)
            }}</span>
            <i style="color: #83879b; font-size: 14px">
              {{ item.productType === 6 ? "个" : "吨" }}</i
            >
          </div>
          <div class="price">
            ¥<span style="font-family: sans-serif; font-weight: 600">{{
              item.listingPrice
            }}</span>
          </div>
          <div class="name">{{ item.contactCompanyName }}</div>
          <!-- <div class="creat" @click="handInBuyDetail(item, 2)">查看</div> -->
        </div>
      </div>
    </div>

    <!-- 成交情况/交易行情 -->
    <div class="tradBox tradDeal">
      <div class="box">
        <div class="boxheader">
          <h3 class="hzuo">交易行情</h3>
          <div class="hmid">
            <!--  @remove-tag="tradeClear" @visible-change="handleblur"-->
            <el-select
              class="hselect"
              popper-class="htypeSelect"
              v-model="tradValue"
              placeholder="产品列表"
              multiple
              size="mini"
              ref="multiSelect"
              style="width: 100%"
              @visible-change="handleblur"
            >
              <template slot="prefix">{{ tradeString }}</template>
              <!-- 选项 -->
              <el-option-group
                v-for="group in options"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                  @click.native.stop="makesureTrade"
                >
                </el-option>
              </el-option-group>
              <!-- 按钮 -->
              <div class="hbtn">
                <!-- <el-button type="primary" size="mini" @click.stop="cacleTrade"
                  >取消</el-button
                > -->
                <!-- 是否记住选择 -->
                <div class="hremberdiv">
                  <el-checkbox
                    v-model="isRemember"
                    @change="handleRememberChange"
                    class="hrember"
                    >记住我的配置</el-checkbox
                  >
                </div>
                <div class="anniu">
                  <el-button @click.stop="tradeClose" type="primary" size="mini"
                    >确定</el-button
                  >
                </div>
              </div>
            </el-select>
          </div>
          <div class="trit" @click="handleInTradeDetail">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div>
        <div class="danwei">
          <span>单位：元</span>
        </div>
        <!-- 折线图 -->
        <div class="boxchart">
          <multiple-lines
            :ydata="y_activeData"
            :xdata="x_activeData"
            :option="optionStyle"
            :smooth="true"
            :series-option="seriesObj"
          />
        </div>
      </div>
      <div class="box">
        <div class="boxheader">
          <h3>成交情况</h3>
          <!-- <div class="trit" @click="handleInMarked">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div> -->
        </div>

        <div class="boxtit dealtit">
          <div class="dname">成交产品</div>
          <div class="dpname" style="text-align: left">
            <span>成交量</span>
            <el-tooltip
              class="item"
              effect="light"
              content="最新交易日成交量"
              placement="top"
            >
              <img class="dsicon" src="../../assets/tipsicon.png" />
            </el-tooltip>
          </div>
          <div class="dpnumber" style="text-align: left">
            <span>上周成交(吨)</span>
            <el-tooltip
              class="item"
              effect="light"
              content="涨跌幅是对比上上周数据"
              placement="top"
            >
              <img class="dsicon" src="../../assets/tipsicon.png" />
            </el-tooltip>
          </div>
          <div class="dprice" style="text-align: left">
            <span>上月成交(吨)</span>
            <el-tooltip
              class="item"
              effect="light"
              content="涨跌幅是对比上上月数据"
              placement="top"
            >
              <img class="dsicon" src="../../assets/tipsicon.png" />
            </el-tooltip>
          </div>
          <div class="dcreat">
            <span>智能分析</span>
            <!-- <svg-icon icon-class="fenxi" /> -->
            <img src="../../assets/mebvip.png" alt="" />
          </div>
        </div>

        <div class="xian" style="margin-bottom: 0px"></div>
        <el-scrollbar class="paiming">
          <div
            class="dealtit dealtdata"
            v-for="(item, index) in dealdata"
            :key="index"
          >
            <div class="dname">{{ item.name }}</div>
            <div class="dpname">
              <span style="font-family: sans-serif; font-weight: 600">{{
                item.last_day ? item.last_day : 0
              }}</span>
            </div>
            <div class="dpnumber">
              <span style="font-family: sans-serif; font-weight: 600">{{
                item.last_week ? item.last_week : 0
              }}</span>
              <span
                style="
                  font-family: sans-serif;
                  font-weight: 600;
                  margin-left: 4px;
                "
                :class="{
                  dred: item.last_week_range > 0,
                  dgreen: item.last_week_range < 0,
                }"
                v-show="
                  item.last_week_range !== 0 &&
                  item.last_week_range !== Infinity
                "
                >{{
                  item.last_week_range > 0
                    ? "+" + item.last_week_range + "%"
                    : item.last_week_range + "%"
                }}</span
              >
            </div>
            <div class="dprice">
              <span style="font-family: sans-serif; font-weight: 600">{{
                item.last_month
              }}</span>
              <span
                style="
                  font-family: sans-serif;
                  font-weight: 600;
                  margin-left: 4px;
                "
                v-show="
                  item.last_month_range !== 0 &&
                  item.last_month_range !== Infinity
                "
                :class="{
                  dred: item.last_month_range > 0,
                  dgreen: item.last_month_range < 0,
                }"
                >{{
                  item.last_month_range > 0
                    ? "+" + item.last_month_range + "%"
                    : item.last_month_range + "%"
                }}</span
              >
            </div>
            <div class="dcreat" @click="handInMarket(item)">查看</div>
          </div>
        </el-scrollbar>
      </div>
    </div>

    <!-- 绿色金融 -->
    <div class="lsjrong">
      <div class="boxheader">
        <h3>绿色金融</h3>
        <div class="trit" @click="handleInJrong">
          <span>更多</span>
          <svg-icon icon-class="trademore" />
        </div>
      </div>
      <div class="lsctent">
        <div
          class="lsmeo"
          v-for="(item, index) in lsData"
          :key="index"
          @click="handleInfinace(item)"
        >
          <img :src="lsImgArry[index].cover_url" />
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>

    <!-- 专家访谈 / 新闻资讯 -->
    <div class="perfictyNew">
      <div class="perficty">
        <!-- <div class="boxheader">
          <h3>专家访谈</h3>
          <div class="trit" @click="handleInPeopleList(1)">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div> -->
        <div class="videos">
          <h3>专家访谈</h3>
          <div
            class="outvido"
            @click="handleVideo(item)"
            v-for="(item, index) in videoData"
            :key="index"
          >
            <div class="vtv">
              <img :src="item.videoCover" />
            </div>
            <!-- <div class="vtxt">{{ item.videoTitle }}</div> -->
          </div>
        </div>
      </div>
      <div class="news" v-if="sortnewsData.length > 0">
        <div class="boxheader boxybao">
          <div class="boxybaotop">
            <h3>碳索研报</h3>
            <div class="trit" @click="handInNewsList">
              <span>更多</span>
              <svg-icon icon-class="trademore" />
            </div>
          </div>
          <div class="boxwenzi">
            <div class="boxzitop">
              <b
                v-show="reporttop[0]['ishave']"
                @click="getIntoReport(reporttop[0].item)"
                >{{ reporttop[0].item.title }}</b
              >
              <span v-show="reporttop[0]['ishave']">|</span>
              <b
                v-show="reporttop[1]['ishave']"
                @click="getIntoReport(reporttop[1].item)"
                >{{ reporttop[1].item.title }}</b
              >
              <span v-show="reporttop[1]['ishave']">|</span>
              <b
                v-show="reporttop[2]['ishave']"
                @click="getIntoReport(reporttop[2].item)"
                >{{ reporttop[2].item.title }}</b
              >
              <span v-show="reporttop[2]['ishave']">|</span>
              <b
                v-show="reporttop[3]['ishave']"
                @click="getIntoReport(reporttop[3].item)"
                >{{ reporttop[3].item.title }}</b
              >
              <span v-show="reporttop[3]['ishave']">|</span>
              <b
                v-show="reporttop[4]['ishave']"
                @click="getIntoReport(reporttop[4].item)"
                >{{ reporttop[4].item.title }}</b
              >
            </div>
            <div class="boxzibot">
              <b
                v-show="reportbot[0]['ishave']"
                @click="getIntoReport(reportbot[0].item)"
                >{{ reportbot[0].item.title }}</b
              >
              <span v-show="reportbot[0]['ishave']">|</span>
              <b
                v-show="reportbot[1]['ishave']"
                @click="getIntoReport(reportbot[1].item)"
                >{{ reportbot[1].item.title }}</b
              >
              <span v-show="reportbot[1]['ishave']">|</span>
              <b
                v-show="reportbot[2]['ishave']"
                @click="getIntoReport(reportbot[2].item)"
                >{{ reportbot[2].item.title }}</b
              >
              <span v-show="reportbot[2]['ishave']">|</span>
              <b
                v-show="reportbot[3]['ishave']"
                @click="getIntoReport(reportbot[3].item)"
                >{{ reportbot[3].item.title }}</b
              >
              <span v-show="reportbot[3]['ishave']">|</span>
              <b
                v-show="reportbot[4]['ishave']"
                @click="getIntoReport(reportbot[4].item)"
                >{{ reportbot[4].item.title }}</b
              >
              <span v-show="reportbot[4]['ishave']">|</span>
              <b
                v-show="reportbot[5]['ishave']"
                @click="getIntoReport(reportbot[5].item)"
                >{{ reportbot[5].item.title }}</b
              >
            </div>
            <div class="boxhr"></div>
          </div>
        </div>
        <div class="nlist">
          <!-- <div class="firstnews" @click="handleInNewsDetail(firstData)">
            <div class="firstleft">
              <img :src="firstData.newsCover" alt="" />
            </div>

            <div class="firstright">
              <div class="rtop">
                <h4>{{ firstData.title }}</h4>
                <span>{{
                  firstData.newsYear +
                  "-" +
                  formatNumber(firstData.newsMonth) +
                  "-" +
                  formatNumber(firstData.newsDay)
                }}</span>
              </div>
              <div class="rbot">
                <p>{{ firstData.subTitle }}<i>[全文]</i></p>
              </div>
            </div>
          </div> -->
          <ul>
            <li
              v-for="item in sortnewsData"
              :key="item.id"
              @click="handleInNewsDetail(item)"
            >
              <div class="lileft">
                <b class="newbs" v-show="item.isNew">NEW</b>
                <img class="imgdefault" src="../../assets/report.png" alt="" />
                <img class="imghover" src="../../assets/report_h.png" alt="" />
                <p>{{ item.reportTitle }}</p>
              </div>

              <b class="newsdate">{{ item.reportUpdateTime }}</b>
            </li>
          </ul>
        </div>
      </div>
      <div class="news" v-else>
        <div class="boxheader boxybao">
          <div class="boxybaotop">
            <h3>碳索研报</h3>
            <div class="trit" @click="handInNewsList">
              <span>更多</span>
              <svg-icon icon-class="trademore" />
            </div>
          </div>
          <div class="boxwenzi">
            <div class="boxzitop">
              <b
                v-show="reporttop[0]['ishave']"
                @click="getIntoReport(reporttop[0].item)"
                >{{ reporttop[0].item.title }}</b
              >
              <span v-show="reporttop[0]['ishave']">|</span>
              <b
                v-show="reporttop[1]['ishave']"
                @click="getIntoReport(reporttop[1].item)"
                >{{ reporttop[1].item.title }}</b
              >
              <span v-show="reporttop[1]['ishave']">|</span>
              <b
                v-show="reporttop[2]['ishave']"
                @click="getIntoReport(reporttop[2].item)"
                >{{ reporttop[2].item.title }}</b
              >
              <span v-show="reporttop[2]['ishave']">|</span>
              <b
                v-show="reporttop[3]['ishave']"
                @click="getIntoReport(reporttop[3].item)"
                >{{ reporttop[3].item.title }}</b
              >
              <span v-show="reporttop[3]['ishave']">|</span>
              <b
                v-show="reporttop[4]['ishave']"
                @click="getIntoReport(reporttop[4].item)"
                >{{ reporttop[4].item.title }}</b
              >
            </div>
            <div class="boxzibot">
              <b
                v-show="reportbot[0]['ishave']"
                @click="getIntoReport(reportbot[0].item)"
                >{{ reportbot[0].item.title }}</b
              >
              <span v-show="reportbot[0]['ishave']">|</span>
              <b
                v-show="reportbot[1]['ishave']"
                @click="getIntoReport(reportbot[1].item)"
                >{{ reportbot[1].item.title }}</b
              >
              <span v-show="reportbot[1]['ishave']">|</span>
              <b
                v-show="reportbot[2]['ishave']"
                @click="getIntoReport(reportbot[2].item)"
                >{{ reportbot[2].item.title }}</b
              >
              <span v-show="reportbot[2]['ishave']">|</span>
              <b
                v-show="reportbot[3]['ishave']"
                @click="getIntoReport(reportbot[3].item)"
                >{{ reportbot[3].item.title }}</b
              >
              <span v-show="reportbot[3]['ishave']">|</span>
              <b
                v-show="reportbot[4]['ishave']"
                @click="getIntoReport(reportbot[4].item)"
                >{{ reportbot[4].item.title }}</b
              >
              <span v-show="reportbot[4]['ishave']">|</span>
              <b
                v-show="reportbot[5]['ishave']"
                @click="getIntoReport(reportbot[5].item)"
                >{{ reportbot[5].item.title }}</b
              >
            </div>
            <div class="boxhr"></div>
          </div>
        </div>
        <el-empty :image-size="100" description="暂无研报数据！"></el-empty>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisibleVideo"
      width="50%"
      :before-close="handleCloseVideo"
      :append-to-body="true"
      custom-class="dialogvideo"
    >
      <div class="video">
        <VideoPlayer
          :src="video.url"
          :pause="pause"
          :autoplay="true"
        ></VideoPlayer>
      </div>
    </el-dialog>

    <Verification
      :dialog-info="dialogVisible"
      :isUserInfo="isUserInfo"
      :iscash="iscash"
      @user-info="changeUserInfo"
      @iscash-info="changeCashInfo"
      @isdalog-close="changeDalogClose"
      @company-info="changeCompanyInfo"
      :stepindex="stepindex"
    ></Verification>
    <!-- 帮助中心 -->
    <!-- <div class="helpsdiv">
      <div class="helpouter" @click="goToHelps">
        <i class="el-icon-question"></i>
      </div>
    </div> -->

    <!-- <div class="perfictyNew">
      <div class="perficty">
        <h3 class="hzhuanjia">专家访谈</h3>
        <div class="peoples">
          <div class="pbox">
            <h4 @click="handleInPeopleList(1)"><span></span>专家学者</h4>
            <ul>
              <li
                @click="handleInPeopleDetail(1, item)"
                v-for="(item, index) in peoplesData1"
                :key="index"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="pbox">
            <h4 @click="handleInPeopleList(2)"><span></span>行业领军人物</h4>
            <ul>
              <li
                @click="handleInPeopleDetail(2, item)"
                v-for="(item, index) in peoplesData2"
                :key="index"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="pbox">
            <h4 @click="handleInPeopleList(3)"><span></span>技术分享</h4>
            <ul>
              <li
                @click="handleInPeopleDetail(3, item)"
                v-for="(item, index) in peoplesData3"
                :key="index"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <h3 class="hvido" @click="handleInVideoList">视频分享</h3>
        <div class="videos">
          <div
            class="outvido"
            @click="handleVideo(item)"
            v-for="(item, index) in videoData"
            :key="index"
          >
            <div class="vtv">
              <img :src="item.videoCover" />
            </div>
            <div class="vtxt">{{ item.videoTitle }}</div>
          </div>
        </div>
      </div>
      <div class="news">
        <div class="boxheader">
          <h3>新闻资讯</h3>
          <div class="trit" @click="handInNewsList">
            <span>更多</span>
            <svg-icon icon-class="trademore" />
          </div>
        </div>
        <div class="nlist">
          <ul>
            <li
              v-for="item in newsData"
              :key="item.id"
              @click="handleInNewsDetail(item)"
            >
              <span></span>
              <p>{{ item.title }}</p>
              <b>{{
                item.newsYear +
                "-" +
                formatNumber(item.newsMonth) +
                "-" +
                formatNumber(item.newsDay)
              }}</b>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  tradeChart,
  tradeList,
  dealListChange,
  listForProfessor,
  newsInfoList,
  videoList,
  tradeMarket,
  tradeLatest,
  tradeLvzheng,
  tradeChongqing,
  tradeFujian,
  tradeGuangdong,
  tradeHubei,
  tradeShanghai,
  tradeShengzhen,
} from "@/api/tradeCenter.js"; //tradeLatest
import { recommedReportList, reportList } from "@/api/report.js"; // 研报
import {
  isPaidMember,
  // setUserDetail,
  // getUserDetail,
  getCompanyInfo,
} from "@/api/user.js"; //tradeLatest
import { getOptions } from "@/api/options.js";
import VideoPlayer from "@/components/VideoPlayer.vue";
import action from "./action.vue";
import { isToken, getInfoTradeUser, saveInfoTradeUser } from "@/api/user.js"; // ,
import store from "@/store";
import {
  moldcity,
  moldtxt,
  moldtype,
  modlname,
  inputmodlname,
  dataTypeMap,
  dataLocationMap,
} from "@/config/trade-mapping";
export default {
  name: "Trading",
  components: {
    VideoPlayer,
    MultipleLines: () => import("@/components/MultipleLines.vue"),
    Verification: () => import("@/components/information/verification.vue"),

    action,
  },
  data() {
    return {
      stepindex: 0, // 步骤条
      // ...existing code...
      moldcity,
      moldtxt,
      moldtype,
      modlname,
      inputmodlname,
      // // 映射关系成交量名称
      dataTypeMap,
      dataLocationMap,
      // ...existing code...
      isManualClose: false, // 是否手动关闭弹窗
      isRemember: false, // 是否记住选择
      curLocation: "全国-挂牌",
      centerCity: [
        {
          name: "全国-挂牌",
          id: 1,
        },
        {
          name: "全国-大宗",
          id: 11,
        },
        {
          name: "北京",
          id: 2,
        },
        {
          name: "上海",
          id: 3,
        },
        {
          name: "广州",
          id: 4,
        },
        {
          name: "深圳",
          id: 8,
        },
        {
          name: "湖北",
          id: 5,
        },
        {
          name: "天津",
          id: 7,
        },
        {
          name: "重庆",
          id: 9,
        },
        {
          name: "福建",
          id: 6,
        },
        // ,{
        //   name:"欧盟",
        //   id:13
        // }
      ],
      timerMarket: null,
      toptitle: "",
      marketObj: {}, // 全国配额
      ccerObj: {}, // ccer价格
      lvzhengObj: {}, // 绿证
      isUserInfo: false, // 是否填入企业信息
      iscash: false, // 是否缴纳保证金
      dialogVisible: false,
      companyObj: {
        // contactCompanyName: "",
        // contactIndustry: "",
        // contactContactor: "",
        // contactNumber: "",
        // contactEmail: "",
        companyName: "",
        industry: "",
        contactorName: "",
        companyNumber: "",
        contactorEmail: "",
      },
      companyRules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请选择行业", trigger: "change" },
        ],
        contactorName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        companyNumber: [
          { required: true, message: "请输入电话", trigger: "blur" },
        ],
        contactorEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
        ],
      },
      newsData: [],
      sortnewsData: [], // 重新排序后的资讯
      reportDataList: [], // 合集列表
      reporttop: [
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
      ], // 上面
      reportbot: [
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
        {
          ishave: false,
          item: {
            title: "",
            id: null,
          },
        },
      ], // 下面
      title: "",
      pause: false,
      video: {
        url: "",
        cover_url: require("../../assets/video.png"),
      },
      videoData: [
        {
          id: 1,
          videoTitle: "绿证绿电培训",
          videoCover:
            "https://tanetong-data-bucket.oss-cn-beijing.aliyuncs.com/2025/07/29/zjiafangtan-5a27fe6d601942a1b5c410f0fffe26eb.png",
          videoUrl:
            "https://tanetong-data-bucket.oss-cn-beijing.aliyuncs.com/video/%E7%BB%BF%E8%AF%81%E7%BB%BF%E7%94%B5%E5%9F%B9%E8%AE%AD.mp4",
          videoType: 1,
          videoOrder: 0,
          videoStatus: 1,
        },
        // {
        //   imgurl: require("../../assets/videoimg.png"),
        //   text: "李志文--一家发电企业的配额量是如何计算",
        //   videourl:
        //     "https://carbon-accounting-test-bucket.oss-cn-beijing.aliyuncs.com/CCER%E9%A1%B9%E7%9B%AE%E5%BC%80%E5%8F%91%E4%BD%93%E7%B3%BB.mp4",
        // }
      ],
      dialogVisibleVideo: false,
      buydata: [],
      saledata: [],
      dealdata: [],
      tradValue: [],
      oldTradValue: [], // 取消按钮用
      options: [],
      optionStyle: {
        legend: {
          type: "scroll",
          width: 530,
          pageIconSize: 8, //翻页按钮大小
          pageIconColor: "#2C86FF", //翻页箭头颜色
          pageIconInactiveColor: "rgba(44,132,251,0.40)", //翻页（即翻页到头时箭头的颜色
          pageTextStyle: {
            color: "#999", //翻页数字颜色
          },
          // padding: [0, 0, 0, 10],
          icon: "roundRect",
          itemWidth: 10,
          itemHeight: 4,
          itemGap: 25,
          bottom: 30,
        },
        tooltip: {
          formatter: function (b) {
            let str = "";
            let date =
              "<div style='text-align:left;margin-bottom:4px'>" +
              b[0].name +
              "</div>";
            for (let i = 0; i < b.length; i++) {
              let stem =
                b[i].marker +
                b[i].seriesName +
                "&nbsp;&nbsp;&nbsp;&nbsp" +
                parseFloat(b[i].value).toFixed(2);
              str +=
                "<div style='text-align:left;margin-bottom:4px;'>" +
                stem +
                "</div>";
            }
            return date + str;
          },
        },
      },
      y_activeData: [],
      // 激活量y轴数据
      // "09-12", "09-13", "09-14", "09-15", "09-16", "09-17"
      x_activeData: [], // 激活量x轴数据
      seriesObj: {
        symbolSize: 6, // 圆圈大小
        symbol: "circle",
        label: {
          show: false,
          position: "top",
          formatter: function (b) {
            return parseFloat(b.value).toFixed(2);
          },
        },
      },
      //专家学者
      peoplesData1: [],
      peoplesData2: [],
      peoplesData3: [],
      allOptions: [],
      currentXdata: [],
      currentAll: {},

      firstData: {},
      transactionType: 0,
      industryOptions: [],
      lsData: [],
      lsImgArry: [
        {
          cover_url: require("../../assets/lsj1.png"),
        },
        {
          cover_url: require("../../assets/lsj2.png"),
        },
        {
          cover_url: require("../../assets/lsj3.png"),
        },
        {
          cover_url: require("../../assets/lsj4.png"),
        },
      ],
      isblur: false, //是否打开了下拉框
      noexpired: false, // 登陆是否过期
      concatObj: {},
    };
  },
  computed: {
    // 交易行情输入框回显
    tradeString() {
      if (this.tradValue.length > 0) {
        let str = this.tradValue.map((item) => {
          return this.inputmodlname[item];
        });
        return str.join("/");
      }
      return "";
    },
  },
  async created() {
    // 判断交易行情设置
    isToken()
      .then((res) => {
        if (res.code === 0 && res.message === "success") {
          // 获取用户信息并赋值给 tradValue
          this.noexpired = false; // 登陆过期
          this.gethangqingInfo();
        } else {
          console.error(res, "判断用户是否登录====");
          if (res.code == -2001) {
            console.log("下拉框展开，没有登陆");
            this.noexpired = true; // 登陆过期
          }
        }
        this.getOptionTradeRenderInit(); // 获取全部筛选项
      })
      .catch((error) => {
        console.error(error);
      });
    // 求购、售卖列表
    this.getTradeList(1);
    this.getTradeList(2);

    // 行业类型
    getOptions("industry")
      .then((res) => {
        // console.log('请求行业', res)
        if (res.code === 0) {
          const { data } = res;
          this.industryOptions = data;
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error, "获取行业失败");
      });
    // 成交列表
    this.getDealList();
    // 专家列表
    // this.getProfessor();
    // 新闻列表
    // this.getNewsList();
    // 研报列表
    this.getReportList();
    // 合集列表
    this.getReportDataList();
    // 绿色金融
    this.getlsList();
    // 视频列表
    // this.getViedeoList();
    // 市场行情
    this.getDataMaket();
    this.startMarket(); // 全国配额
    this.getMarketCCER(); // CCER 价格
    this.getMarketLvzheng(); // 绿证价格
  },
  destroyed() {
    // 在页面销毁时清除定时器和接口请求
    this.stopTimer();
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
  methods: {
    // 接收企业信息回调
    changeCompanyInfo(obj) {
      this.concatObj = obj;
    },
    // 是否关闭弹窗回调
    changeDalogClose(isClose) {
      this.dialogVisible = isClose;
    },
    // 是否填写企业信息回调
    changeUserInfo(isUserInfo) {
      this.isUserInfo = isUserInfo;
    },
    // 是否缴纳保证金回调
    changeCashInfo(iscash) {
      this.iscash = iscash;
    },
    // 交易行情渲染
    getOptionTradeRenderInit() {
      // 获取全部筛选项
      getOptions("tradeCenterDataType")
        .then((res) => {
          if (res.code === 0) {
            const { data } = res;
            // console.error(data, "获取全部筛选项====");
            // 找到code为1的对象
            const targetItem = data.find((item) => item.code === 1);

            if (targetItem && targetItem.subOption) {
              // 找到subOption中code为11的元素的索引
              const index = targetItem.subOption.findIndex(
                (sub) => sub.code === 11
              );

              if (index !== -1) {
                // 移除该元素
                const [itemToMove] = targetItem.subOption.splice(index, 1);
                // 插入到第二个位置（索引为1）
                targetItem.subOption.splice(1, 0, itemToMove);
              }
            }
            data.map((item) => {
              let obj = {
                code: item.code,
                label: "",
                options: [],
              };
              obj.label = this.moldtxt[item.code];
              if (item.subOption.length > 0) {
                item.subOption.map((sitm) => {
                  let slabel = item.code + "-" + sitm.code;
                  obj.options.push({
                    code: sitm.code,
                    value: this.moldtype[item.code] + sitm.code,
                    label: this.moldcity[slabel],
                    disabled: true,
                  });
                });
              }
              this.allOptions.push(obj);
            });
            this.renderTradeXy();
            // console.error(this.allOptions, "获取全部筛选项");
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error, "获取失败");
        });
    },
    // 记住选择
    handleRememberChange(val) {
      console.log("记住选择:", val);
      // 判断是否登陆
      //校验token
      isToken().then((res) => {
        // console.error(res, "判断用户是否登录====");
        if (res.code === 0 && res.message === "success") {
          // 获取个人设置信息
          this.getTradeInfo();
        } else {
          this.isRemember = false;
          if (res.code == -2001) {
            this.$messagebox
              .confirm("请登录以继续操作。", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                showClose: false,
                closeOnClickModal: false,
                showCancelButton: true,
                type: "warning",
              })
              .then(() => {
                store.dispatch("user/resetToken").then(() => {
                  // location.reload();
                  this.$router.push({ path: "/login" });
                });
              });
          }
        }
      });
    },
    // 获取userId&&设置交易行情信息
    getTradeInfo() {
      let ccerDetail = []; // 用于保存 ccer 的详细信息
      let eaDetail = []; // 用于保存 ea 的详细信息
      // 保存用户的交易行情设置信息
      this.tradValue.forEach((item) => {
        if (item.startsWith("ea")) {
          // 提取 ea 后的数字部分并转为整数
          const number = parseInt(item.substring(2), 10);
          eaDetail.push(number);
        } else if (item.startsWith("ccer")) {
          // 提取 ccer 后的数字部分并转为整数
          const number = parseInt(item.substring(4), 10);
          ccerDetail.push(number);
        }
      });
      saveInfoTradeUser({
        ccerDetail: this.isRemember ? ccerDetail : [1],
        eaDetail: this.isRemember ? eaDetail : [1, 2, 3, 4, 5, 6, 7, 8, 9, 11],
        otherDetail: [],
      })
        .then((res) => {
          if (res.code === 0) {
            if (this.isRemember && this.isblur) {
              this.$message({
                message: "交易行情设置信息已保存",
                type: "success",
              });
            }
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error, "保存交易行情设置信息失败");
        });
    },
    // 获取userId&&交易行情信息
    gethangqingInfo() {
      getCompanyInfo()
        .then((res) => {
          // console.error(res, "用户信息====");
          if (res.code === 0) {
            let { userId } = res.data;
            getInfoTradeUser({ userId: userId })
              .then((res) => {
                // console.error(res, "交易行情的设置信息====");
                if (res.code === 0) {
                  let { ccerDetail, eaDetail } = res.data;
                  let result = [];
                  // 添加 ea 前缀的元素
                  eaDetail.forEach((num) => {
                    result.push(`ea${num}`);
                  });

                  // 添加 ccer 前缀的元素
                  ccerDetail.forEach((num) => {
                    result.push(`ccer${num}`);
                  });
                  this.tradValue = result;
                  // console.error(this.tradValue, "交易行情的设置信息====");
                } else {
                  this.$message({
                    message: res.message,
                    type: "warning",
                  });
                }
              })
              .catch((error) => {
                console.log(error, "获取交易行情的设置信息失败");
              });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getMarketLocation(item) {
      this.curLocation = item.name;
      if (item.name !== "全国-挂牌") {
        this.stopTimer();
      } else {
        this.startMarket();
      }
      switch (item.name) {
        case "全国-挂牌":
          this.getDataMaket();
          break;
        case "全国-大宗":
          this.getDaZhongMaket();
          break;
        case "重庆":
          this.getMarketChongqing();
          break;
        case "福建":
          this.getMarketFujian();
          break;
        case "广州":
          this.getMarketGuangdong();
          break;
        case "湖北":
          this.getMarketHubei();
          break;
        case "上海":
          this.getMarketShanghai();
          break;
        case "深圳":
          this.getMarketShengzhen();
          break;
        case "北京":
          this.getMarketBeijing();
          break;
        case "天津":
          this.getMarketTianjin();
          break;
        default:
          break;
      }
    },
    // 全国大宗
    getDaZhongMaket() {
      tradeLatest({
        dataLocation: 11,
        dataType: 1,
      })
        .then((res) => {
          console.error(res, "全国dazhong======");
          if (res.code === 0) {
            // this.ccerObj = res.data;
            this.marketObj = res.data;
            this.marketObj.latestPrice = res.data.averagePrice;
            // console.error(this.marketObj, "ddd");
            this.marketObj.currDate = this.convertDateFormat(res.data.dataDate);
            this.marketObj.totalAmount = String(res.data.totalAmount);
            this.marketObj.totalNum = String(res.data.totalNum);
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 北京
    getMarketBeijing() {
      tradeLatest({
        // dataLocation: item ? item.id : 1,
        dataLocation: 2,
        dataType: 1,
      })
        .then((res) => {
          console.error(res, "beijing======");
          if (res.code === 0) {
            // this.ccerObj = res.data;
            this.marketObj = res.data;
            this.marketObj.latestPrice = res.data.averagePrice;
            // console.error(this.marketObj, "ddd");
            this.marketObj.currDate = this.convertDateFormat(res.data.dataDate);
            this.marketObj.totalAmount = String(res.data.totalAmount);
            this.marketObj.totalNum = String(res.data.totalNum);

            // console.error(this.marketObj);
            // this.marketObj.currDate = res.data.dataDate
            //   ? this.formateMarket(res.data.dataDate)
            //   : "--";
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 天津
    getMarketTianjin() {
      tradeLatest({
        // dataLocation: item ? item.id : 1,
        dataLocation: 7,
        dataType: 1,
      })
        .then((res) => {
          console.error(res, "tianjin======");
          if (res.code === 0) {
            // this.ccerObj = res.data;
            this.marketObj = res.data;
            this.marketObj.latestPrice = res.data.averagePrice;
            // console.error(this.marketObj, "ddd");
            this.marketObj.currDate = this.convertDateFormat(res.data.dataDate);
            this.marketObj.totalAmount = String(res.data.totalAmount);
            this.marketObj.totalNum = String(res.data.totalNum);
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    convertDateFormat(dateString) {
      // 检查输入是否为8位数字
      // if (dateString.length !== 8 || !/^\d{8}$/.test(dateString)) {
      //   throw new Error("Invalid date format. Expected format is YYYYMMDD.");
      // }
      let dateString2 = String(dateString);

      // 提取年、月、日
      let year = dateString2.substring(0, 4);
      let month = dateString2.substring(4, 6);
      let day = dateString2.substring(6, 8);

      // 确保月份和日期是两位数
      month = month.padStart(2, "0");
      day = day.padStart(2, "0");

      // 组合成"YYYY-MM-dd"格式
      return `${year}-${month}-${day}`;
    },
    // 重庆
    getMarketChongqing() {
      tradeChongqing()
        .then((res) => {
          if (res.code === 0) {
            console.error("重庆行情====", res);
            this.marketObj = res.data;
            this.marketObj.currDate = res.data.currDate
              ? this.formateMarket(res.data.currDate)
              : "--";
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //福建
    getMarketFujian() {
      tradeFujian()
        .then((res) => {
          if (res.code === 0) {
            console.error("福建行情====", res);
            this.marketObj = res.data;
            this.marketObj.currDate = res.data.currDate
              ? this.formateMarket(res.data.currDate)
              : "--";
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //广东
    getMarketGuangdong() {
      tradeGuangdong()
        .then((res) => {
          if (res.code === 0) {
            console.error("广东行情====", res);
            this.marketObj = res.data;
            this.marketObj.currDate = res.data.currDate
              ? this.formateMarket(res.data.currDate)
              : "--";
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //湖北
    getMarketHubei() {
      tradeHubei()
        .then((res) => {
          if (res.code === 0) {
            console.error("湖北行情====", res);
            this.marketObj = res.data;
            this.marketObj.currDate = res.data.currDate
              ? this.formateMarket(res.data.currDate)
              : "--";
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //上海
    getMarketShanghai() {
      tradeShanghai()
        .then((res) => {
          if (res.code === 0) {
            console.error("上海行情====", res);
            this.marketObj = res.data;
            this.marketObj.currDate = res.data.currDate
              ? this.formateMarket(res.data.currDate)
              : "--";
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //深圳
    getMarketShengzhen() {
      tradeShengzhen()
        .then((res) => {
          if (res.code === 0) {
            console.error("深圳行情====", res);
            this.marketObj = res.data;
            this.marketObj.currDate = res.data.currDate
              ? this.formateMarket(res.data.currDate)
              : "--";
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getMarketLvzheng() {
      tradeLvzheng()
        .then((res) => {
          if (res.code === 0) {
            this.lvzhengObj = res.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getMarketCCER() {
      tradeLatest({
        // dataLocation: item ? item.id : 1,
        dataLocation: 1,
        dataType: 2,
      })
        .then((res) => {
          // console.error(res, "ccer======");
          if (res.code === 0) {
            this.ccerObj = res.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    isStockMarketOpen() {
      const now = new Date();
      const dayOfWeek = now.getDay();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      // 判断是否为周六或周日
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        return false;
      }
      // 判断是否在股票交易时间范围内（假设为纽约证券交易所时间）
      if (
        (hours === 9 && minutes >= 30) ||
        (hours > 9 && hours < 15) ||
        (hours === 15 && minutes === 0)
      ) {
        return true;
      }
      return false;
    },
    stopTimer() {
      if (this.timerMarket) {
        clearInterval(this.timerMarket);
      }
    },
    startMarket() {
      this.timerMarket = setInterval(() => {
        this.getDataMaket();
      }, 60000);
    },
    getDataMaket() {
      tradeMarket()
        .then((res) => {
          if (res.code === 0) {
            // console.error("市场行情====", res);
            this.marketObj = res.data;
            this.marketObj.currDate = this.formateMarket(res.data.currDate);
            // if(this.marketObj.totalAmount){
            //   this.marketObj.tot
            // }
            // this.marketObj.riseFall = num;
            if (this.isStockMarketOpen()) {
              // 是否是股票交易时间
              this.toptitle = "最新";
            } else {
              this.toptitle = "收盘";
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    handleInfinace(item) {
      this.$router.push({
        path: "/finance?code=" + item.id,
      });
    },
    handleInJrong() {
      this.$router.push({
        path: "/finance?code=22",
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 视频列表
    getViedeoList() {
      videoList()
        .then((res) => {
          if (res.code === 0) {
            // console.error(res, "视频===");
            this.videoData = res.data;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 新闻详情
    handleInNewsDetail(item) {
      this.$router.push({
        path: "/reportPreview?reportId=" + item.id,
      });
    },
    formatNumber(num) {
      const formattedNum = String(num).padStart(2, "0");
      return formattedNum;
    },
    // 新闻列表
    getNewsList() {
      newsInfoList({
        currentPage: 1,
        pageSize: 5,
        newsType: 1,
      })
        .then((res) => {
          if (res.code === 0) {
            //console.error("新闻列表===", res);
            // this.newsData = res.data.list;
            let arry =
              res.data.list.length >= 5
                ? res.data.list.slice(1, 5)
                : res.data.list;
            this.newsData = arry;
            this.firstData = res.data.list[0];
            if (this.firstData.subTitle.length > 70) {
              this.firstData.subTitle =
                this.firstData.subTitle.substring(0, 70) + "...";
            }
            // console.error(this.firstData.subTitle.length);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getIntoReport(item) {
      const collectionId = item.id;
      this.$router.push("/reportList?collectionId=" + collectionId);
    },
    // 研报合集列表
    getReportDataList() {
      reportList()
        .then((res) => {
          if (res.code === 0) {
            this.reportDataList = res.data;
            // console.error(this.reportDataList)
            let top = this.reportDataList.slice(0, 5);
            let bot = this.reportDataList.slice(5, 20);
            // console.error(top,bot)
            top.map((item, index) => {
              this.reporttop[index]["ishave"] =
                item.reportNumber > 0 ? true : false;
              this.reporttop[index].item.title = item.collectionTitle;
              this.reporttop[index].item.id = item.id;
            });
            bot.map((item, index) => {
              this.reportbot[index]["ishave"] =
                item.reportNumber > 0 ? true : false;
              this.reportbot[index].item.title = item.collectionTitle;
              this.reportbot[index].item.id = item.id;
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 研报列表-首页推荐
    getReportList() {
      recommedReportList()
        .then((res) => {
          if (res.code === 0) {
            // console.error("研报列表===", res);
            this.newsData = res.data;
            //     this.newsData = [{
            //     "id": 8,
            //     "collectionId": 1,
            //     "reportTitle": "贵州茅台测试2",
            //     "pageNumber": 20,
            //     "releaseTime": 1707235200000,
            //     "previewList": null,
            //     "reportUpdateTime": "2025-02-10 14:51:02"
            // }]
            let fivedaysTime = this.getTimestampFiveDaysAgo();
            this.newsData.map((item) => {
              const reportUpdateTimeTimestamp =
                new Date(item.reportUpdateTime).getTime() / 1000;
              if (reportUpdateTimeTimestamp < fivedaysTime) {
                item.isNew = false;
              } else {
                item.isNew = true;
              }
              item.reportUpdateTime = item.reportUpdateTime.split(" ")[0];
            });
            if (this.newsData.length > 5) {
              this.newsData = this.newsData.slice(0, 5);
            }
            this.sortnewsData = this.newsData.sort((a, b) => b.isNew - a.isNew);
            // console.error(this.sortnewsData,"dcccc")
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 距离当今时间5天前的时间戳返回
    getTimestampFiveDaysAgo() {
      const now = new Date();
      const fiveDaysAgo = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000);
      return Math.floor(fiveDaysAgo.getTime() / 1000);
    },
    // 格式化时间戳
    formatTimestampToDate(timestamp) {
      const date = new Date(timestamp * 1000); // 将时间戳转换为毫秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 绿色金融
    getlsList() {
      getOptions("newsType")
        .then((res) => {
          if (res.code === 0) {
            // console.error(res.data, "绿色金融");
            res.data.map((item) => {
              if (item.code === 2) {
                item.subOption.map((sitm) => {
                  this.lsData.push({
                    id: sitm.code,
                    title: sitm.value,
                  });
                });
              }
            });
            // this.lsData = res.data;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      // newsInfoList({
      //   currentPage: 1,
      //   pageSize: 4,
      //   newsType: 2,
      // })
      //   .then((res) => {
      //     if (res.code === 0) {
      //       // console.error(res.data, "ddd");
      //       this.lsData = res.data.list;
      //     } else {
      //       this.$message({
      //         message: res.message,
      //         type: "error",
      //       });
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    // 专家列表
    getProfessor() {
      listForProfessor()
        .then((res) => {
          // console.error("列表===", res);

          if (res.code === 0) {
            this.peoplesData1 = res.data["1"];
            this.peoplesData2 = res.data["2"];
            this.peoplesData3 = res.data["3"];
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 帮助中心
    goToHelps() {
      this.$router.push({
        path: "/helps",
      });
    },
    flattenData(nestedData) {
      const resultMap = new Map();
      // 遍历顶层对象
      for (const level1Key in nestedData) {
        const level1Value = nestedData[level1Key];

        // 遍历第二层对象
        for (const level2Key in level1Value) {
          const dataArray = level1Value[level2Key];

          // 遍历数据数组
          dataArray.forEach((item) => {
            const { dataLocation, dataType, period, totalNum } = item;
            const key = `${dataLocation}-${dataType}`;

            // 如果没有该组合的对象，则创建一个
            if (!resultMap.has(key)) {
              resultMap.set(key, {
                dataLocation,
                dataType,
                last_day: 0,
                last_week: 0,
                prev_week: 0,
                last_month: 0,
                prev_month: 0,
              });
            }

            // 更新对应周期的值
            const obj = resultMap.get(key);
            obj[period] = totalNum;
          });
        }
      }
      // 将 Map 转换为数组并处理映射和计算
      return Array.from(resultMap.values())
        .filter(
          (item) =>
            item.last_day !== 0 ||
            item.last_week !== 0 ||
            item.prev_week !== 0 ||
            item.last_month !== 0 ||
            item.prev_month !== 0
        )
        .map((item) => {
          let name = "";
          // 添加映射名称
          if (item.dataLocation === 1 && item.dataType === 2) {
            name = "CCER - 全国";
          } else {
            name = `${this.dataTypeMap[item.dataType] || "未知类型"} - ${
              this.dataLocationMap[item.dataLocation] || "未知地点"
            }`;
          }
          item.name = name;

          // 计算涨幅
          item.last_week_range = this.calculateChangeRate(
            item.last_week,
            item.prev_week
          );
          item.last_month_range = this.calculateChangeRate(
            item.last_month,
            item.prev_month
          );

          return item;
        });
    },
    // 计算变化率函数
    calculateChangeRate(current, previous) {
      // else if (!current || !previous) {
      //   return 0; // 如果当前值或前一个值为 null 或 undefined，返回 0
      // }
      // console.error(current, previous, "计算变化率====");
      if (previous === 0) {
        return current === 0 ? 0 : Infinity; // 防止除以零
      } else {
        return parseInt(((current - previous) / previous) * 100); // 返回百分比
      }
    },
    // 查看成交情况
    handInMarket(item) {
      isPaidMember().then((res) => {
        if (res.code === 0) {
          if (res.data.result === false) {
            // 不是会员，给提示
            this.$message({
              message: "您不是会员，前去会员中心充值吧！",
              type: "warning",
            });
          } else {
            // 跳转详情
            this.$router.push({
              path:
                "/market?cityValue=" + item.dataType + "-" + item.dataLocation,
            });
          }
        } else {
          if (res.code == -2001) {
            this.$messagebox
              .confirm("请登录以继续操作。", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                showClose: false,
                closeOnClickModal: false,
                showCancelButton: true,
                type: "warning",
              })
              .then(() => {
                store.dispatch("user/resetToken").then(() => {
                  // location.reload();
                  this.$router.push({ path: "/login" });
                });
              });
          }
        }
      });
    },
    // 成交情况
    getDealList() {
      dealListChange()
        .then((res) => {
          if (res.code === 0) {
            // console.error("成交情况====", res);
            let data = res.data;
            // 将数据转换为平坦结构
            this.dealdata = this.flattenData(data);
            // console.error(this.dealdata, "平坦化后的数据");
            // this.dealdata = res.data;
            // this.dealdata = [
            //   {
            //     name: "配额-全国",
            //     yesterdayTurnover: 100,
            //     dayBeforeYesterdayTurnover: 200,
            //     incrementRatio: -23,
            //   },
            // ];
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 查看详情
    handInBuyDetail(item, val) {
      let id = item.id;
      // 清空筛选参数
      this.$store.dispatch("select/clearPachSelect", "");
      this.$router.push({
        path: "/buydetail?listingId=" + id + "&transactionType=" + val,
      });
    },
    // 更多研报
    handInNewsList() {
      this.$router.push({
        path: "/reports",
      });
    },
    // 千分符
    addThousandsSeparator(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 求购、售卖列表
    getTradeList(transactionType) {
      tradeList({
        transactionType: transactionType,
      })
        .then((res) => {
          // console.error("求购列表=====", res);
          if (res.code === 0) {
            let arry = res.data.length >= 8 ? res.data.slice(0, 8) : res.data;

            if (transactionType === 1) {
              this.buydata = arry;
            } else {
              this.saledata = arry;
            }
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 我要买
    handeInBuy(val) {
      //   this.$router.push({ path: "/buy" });
      // console.error(window._czc,"我要买");
      if (window._czc) {
        window._czc.push(["_trackEvent", "首页-我要买｜我要卖", "点击"]);
      }
      this.transactionType = val;
      //校验token
      isToken().then((res) => {
        // console.error(res, "判断用户是否登录====");
        if (res.code === 0 && res.message === "success") {
          console.error(this.concatObj, "用户信息====");
          if (this.concatObj.companyInfoStatus === 4) {
            this.dialogVisible = false;
            this.$router.push({
              path: "/buy?transactionType=" + this.transactionType,
            });
          } else {
            this.dialogVisible = true;
          }
        } else {
          if (res.code == -2001) {
            this.$messagebox
              .confirm("请登录以继续操作。", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                showClose: false,
                closeOnClickModal: false,
                showCancelButton: true,
                type: "warning",
              })
              .then(() => {
                store.dispatch("user/resetToken").then(() => {
                  // location.reload();
                  this.$router.push({ path: "/login" });
                });
              });
          }
        }
      });
    },
    // 进入求购/售卖-大厅
    handInBuyList(val) {
      // 清空筛选参数
      this.$store.dispatch("select/clearPachSelect", "");
      this.$router.push({ path: "/buylist?transactionType=" + val });
    },

    // 进入详情页
    handleInTradeDetail() {
      this.$router.push({ path: "/tradetail" });
    },
    // 渲染x、y轴数据
    renderTradeXy() {
      // 获取交易行情数据
      let randomColos = this.generateRandomColors(30);
      let startday = this.getRecentMonthArray()[1];
      let endday = this.getRecentMonthArray()[0];
      let ydata = [];
      let xdata = [];
      tradeChart({
        startDate: startday,
        endDate: endday,
      })
        .then((res) => {
          // console.error(res);
          if (res.code === 0) {
            // 用户选项处理
            let optionMap = res.data.optionMap;
            for (const key in optionMap) {
              let oIndex = this.allOptions.findIndex((item) => {
                return String(item.code) === key;
              });
              let code = this.allOptions[oIndex].code;
              this.allOptions[oIndex].options.map((item) => {
                if (optionMap[code].includes(item.code)) {
                  item.disabled = false;
                }
              });
            }
            this.options = this.allOptions;
            // console.error(this.options, "ddddd");
            // 处理x,y数据，单价向前补零
            let alldata = res.data.detailMap;
            this.currentXdata = res.data.dataDate;
            for (const key in alldata) {
              let arry = alldata[key];
              for (const ikey in arry) {
                let curentKey = this.moldtype[key] + ikey;
                let dataarry = this.insertMissingDates(
                  arry[ikey],
                  this.currentXdata
                );
                this.currentAll[curentKey] = dataarry[0];
                if (this.noexpired) {
                  this.tradValue.push(curentKey);
                }
              }
            }
            // console.error(this.tradValue, "tradvalue======");
            this.tradValue.map((item, index) => {
              ydata.push({
                color: randomColos[index],
                name: this.modlname[item],
                data: this.currentAll[item],
              });
            });
            xdata = this.formatDateArray(this.currentXdata);
            this.y_activeData = ydata;
            this.x_activeData = xdata;
            // console.error(this.currentAll, this.y_activeData, "dddd");
          } else {
            if (res.msg) {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 进入视频列表
    handleInVideoList() {
      this.$router.push({ path: "/videos" });
    },
    // 查看视频
    handleVideo(item) {
      this.dialogVisibleVideo = true;
      this.video.url = item.videoUrl;
      this.title = item.videoTitle;
    },
    handleCloseVideo() {
      this.dialogVisibleVideo = false;
      this.pause = true;
    },
    // 专家列表
    handleInPeopleList(val) {
      this.$router.push({ path: "/professor?expertType=" + String(val) });
    },
    // 专家列表访谈详情
    handleInPeopleDetail(val, item) {
      this.$router.push({
        path:
          "/peopledetail??expertType=" +
          String(val) +
          "&expertInfoId=" +
          item.id,
      });
    },
    // 失去焦点时触发
    handleblur(val) {
      // console.error(val, "失去焦点时触发");
      this.isblur = val;
      if (!val) {
        // 关闭下拉框时
        if (this.isRemember) {
          // 保存记录
          this.getTradeInfo();
        }
      }
      // if (val) {
      //   // 打开下拉框时
      //   this.oldTradValue = [...this.tradValue];
      // } else {
      //   this.tradValue = [...this.oldTradValue]; // 恢复原值
      // }
      // if (val && this.$refs.multiSelect) {
      //   // 点击出现下拉框时
      //   // 打开下拉框时保存原始值
      //   this.oldTradValue = [...this.tradValue];
      // }
      // if (!val && this.$refs.multiSelect) {
      //   // 手动关闭下拉框时
      //   if (this.isManualClose) {
      //     this.isManualClose = false; // 重置手动关闭标志
      //     return; // 如果是手动关闭，则不执行下面的代码
      //   }
      //   this.$refs.multiSelect.toggleMenu();
      // }
    },
    // 点击取消按钮
    cacleTrade() {
      // this.$refs.multiSelect.visible = false;
      if (this.$refs.multiSelect) {
        this.tradValue = [...this.oldTradValue]; // 恢复原值
        this.isManualClose = true; // 设置手动关闭标志
        this.$refs.multiSelect.blur(); // 强制关闭下拉框
      }
    },
    // 点击确定按钮
    tradeClose() {
      this.changeTrade();
      // this.oldTradValue = [...this.tradValue]; // 更新原始值
      this.$refs.multiSelect.blur(); // 强制关闭下拉框
      // this.$refs.multiSelect.visible = false;
      // if (this.$refs.multiSelect) {
      //   this.isManualClose = true; // 设置手动关闭标志
      //   this.$refs.multiSelect.blur(); // 强制关闭下拉框
      // }
    },
    makesureTrade() {
      this.changeTrade();
    },
    // 清除
    tradeClear() {
      //   console.error(this.tradValue, "clear=====");
      this.changeTrade();
    },
    // 用户选择数据切换
    changeTrade() {
      let ydata = [];
      let xdata = [];
      let randomColos = this.generateRandomColors(30);
      //   切换数据
      this.tradValue.map((item, index) => {
        ydata.push({
          color: randomColos[index],
          name: this.modlname[item],
          data: this.currentAll[item],
        });
      });
      xdata = this.formatDateArray(this.currentXdata);
      this.y_activeData = ydata;
      this.x_activeData = xdata;
    },
    // 获取当天日期和前30天的日期
    getRecentMonthArray() {
      var dates = [];
      var today = new Date();
      // 获取今天的日期
      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, "0");
      var day = String(today.getDate()).padStart(2, "0");
      var todayDate = year + month + day;
      dates.push(todayDate);
      // 获取30天前的日期
      var thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
      var tyear = thirtyDaysAgo.getFullYear();
      var tmonth = String(thirtyDaysAgo.getMonth() + 1).padStart(2, "0");
      var tday = String(thirtyDaysAgo.getDate()).padStart(2, "0");
      var thirtyDaysAgoDate = tyear + tmonth + tday;
      dates.push(thirtyDaysAgoDate);
      return dates;
    },
    // 处理日期格式
    formatDateArray(dateArray) {
      return dateArray.map((date) => {
        // const year = date.toString().slice(0, 4);
        const month = date.toString().slice(4, 6);
        const day = date.toString().slice(6, 8);
        return `${month}-${day}`;
      });
    },
    formateMarket(date) {
      if (date) {
        const year = date.slice(0, 4);
        const month = date.slice(4, 6);
        const day = date.slice(6, 8);
        return `${year}-${month}-${day}`;
      }
    },
    // 插入数据
    insertMissingDates(a, b) {
      // 遍历数组b中的每一项
      for (let i = 0; i < b.length; i++) {
        let found = false;
        // 遍历数组a中的每一个对象
        for (let j = 0; j < a.length; j++) {
          // 如果数组a中的dataDate属性值等于数组b中的当前项
          if (a[j].dataDate === b[i]) {
            found = true;
            break;
          }
        }
        // 如果数组a中没有找到与数组b中当前项相等的dataDate属性值
        if (!found) {
          // 在数组a中插入一个新的对象，dataDate属性值为数组b中的当前项
          a.push({
            dataDate: b[i],
            averagePrice: 0,
            totalNum: 0,
            totalAmount: 0,
          });
        }
      }
      // 按dataDate值从小到大排序数组a
      a.sort((x, y) => x.dataDate - y.dataDate);
      let arryprice = [];
      for (let i = 0; i < a.length; i++) {
        if (a[i].averagePrice === 0 && i !== 0) {
          a[i].averagePrice = a[i - 1].averagePrice;
        }
        arryprice.push(parseFloat(a[i].averagePrice).toFixed(2));
      }
      return [arryprice, a];
    },
    // 字符串转浮点数
    formatToMillionths(valueStr) {
      // 首先将字符串转换为浮点数
      const value = parseFloat(valueStr.replace(/,/g, ""));
      // 然后格式化为以万为单位，保留两位小数，并添加千分符
      const formattedValue = value / 10000; // 除以10000转换为万
      const formattedStr = formattedValue
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // 保留两位小数并添加千分符

      return formattedStr;
    },
    // 随机生成30个色值
    generateRandomColors(num) {
      var colors = [];
      for (var i = 0; i < num; i++) {
        var color = "#" + Math.floor(Math.random() * 16777215).toString(16);
        colors.push(color);
      }
      return [
        "#4aab3d",
        "#3a97e5",
        "#ff7a45",
        "#b37feb",
        "#f8db15",
        "#37CFCA",
        "#40a8ff",
        "#ff7a45",
        "#ffa940",
        "#fe4d4f",
        "#ff7a45",
        "#b37feb",
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
ul,
li {
  list-style: none;
}
.checkSave {
  text-align: right;
  line-height: 30px;
  padding-bottom: 50px;
  span {
    padding: 7px 24px;
    border-radius: 4px;
    cursor: pointer;
  }
  span.check {
    font-size: 14px;
    color: #4aab3d;
    border: 1px solid #4aab3d;
    margin-right: 15px;
  }
  span.save {
    font-size: 14px;
    color: #fff;
    background-color: #4aab3d;
  }
}
.checkdiago {
  padding-bottom: 0px;
}

p.tips {
  font-size: 14px;
  color: #83879b;
  margin-bottom: 24px;
}
.tradContainer {
  margin-top: 0px;
  background: #f6f7f8;
  padding-bottom: 40px;
  .tradHeader {
    width: 100%;
    height: 104px;
    padding-top: 436px;
    margin-bottom: 32px;
    // background-color: #edf3fc;
    // background: linear-gradient(90deg, #dcecf7 39.86%, #e5f0fa 82.71%);
    background-image: url("../../assets/bannerlink.png");
    background-position: center top;
    position: relative;
    .content {
      width: 1200px;
      height: 320px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      .linktu {
        width: 853px;
        height: 320px;
        // border: 1px solid red;
        position: absolute;
        right: 0px;
        top: 0px;
        img {
          width: 853px;
          height: 320px;
        }
      }
      h3 {
        font-size: 36px;
        font-weight: 600;
        color: #03102b;
        text-align: left;
        margin-top: 88px;
      }
      .linkouter {
        // display: flex;
        // flex-direction: row;
        // justify-content: space-between;
        // align-items: flex-end;
        position: absolute;
        left: 0px;
        top: 0px;
        .left {
          display: flex;
          flex-direction: row;
          .imgtext {
            margin-left: 10px;
            margin-right: 20px;
            .imgdiv {
              width: 64px;
              img {
                width: 100%;
              }
            }
            .imgtxt {
              font-size: 20px;
              color: #03102b;
              font-weight: 400;
            }
          }
        }
        .right {
          margin-top: 40px;
          font-size: 18px;
          color: #fff;
          display: flex;
          flex-direction: row;
          font-weight: 600;
        }
      }
    }
  }
  .boxheader {
    width: 100%;
    overflow: hidden;
    padding-top: 24px;
    margin-bottom: 0px;

    h3 {
      font-size: 18px;
      font-weight: 600;
      color: #03102b;
      text-align: left;
      line-height: 26px;
      width: 50%;
      float: left;

      padding-left: 24px;
      img {
        width: 32px;
        height: 32px;
        display: inline-block;
        margin-right: 10px;
      }
    }
    .trit {
      width: auto;
      display: block;
      float: right;
      text-align: right;
      line-height: 22px;
      padding-right: 20px;
      cursor: pointer;
      span {
        font-size: 14px;
        color: #03102b;
        opacity: 0.4;
        vertical-align: middle;
      }

      svg {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        display: inline-block;
        color: #03102b;
        opacity: 0.4;
      }
    }
    .trit:hover {
      span {
        color: #4aab3d;
        opacity: 1;
      }
      svg {
        color: #4aab3d;
        opacity: 1;
      }
    }
  }
  .boxybao {
    padding-top: 0px;
    // .boxybaotop{width: 100%;}
    .boxwenzi {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      color: #4aab3d;
      .boxzitop {
        width: 100%;
        margin-top: 16px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }
      .boxzibot {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }
      .boxhr {
        width: 100%;
        height: 0.5px;
        background-color: rgba(3, 16, 43, 0.12);
        margin-top: 18px;
      }
      b {
        font-size: 13px;
        cursor: pointer;
      }
      span {
        // width: 1px;
        // height: 10px;
        // display: inline-block;
        color: #83879b;
        margin-left: 8px;
        margin-right: 8px;
      }
    }
  }
  .boxqiugou {
    // opacity: 0.25;
    background: linear-gradient(
      90deg,
      rgba(103, 216, 115, 0.25) 0%,
      rgba(41, 211, 26, 0.25) 100%
    );
    // background-color: #e1f8e3;
    h3 {
      color: #03102b;
      line-height: 60px;
      svg {
        width: 32px;
        height: 32px;
        vertical-align: middle;
        margin-right: 8px;
      }
      span {
        margin-top: 2px;
      }
    }
    padding-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 12px;
  }
  .boxshoumai {
    // opacity: 0.6;
    background: linear-gradient(
      160deg,
      rgba(193, 232, 255, 0.75) 0%,
      rgba(212, 239, 254, 0.75) 100%
    );
    // background-color: #dff4ff;
    h3 {
      color: #03102b;
      line-height: 60px;
      svg {
        width: 32px;
        height: 32px;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
    padding-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 12px;
  }
  .boxchart {
    height: 389px;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 28px;
  }
  .tradBox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 24px;
    .box {
      background-color: #fff;
      width: 592px;
      height: 470px;
      position: relative;
      .boxtit {
        width: 544px;
        // display: flex;
        white-space: nowrap;
        flex-direction: row;
        line-height: 22px;
        padding-left: 24px;
        padding-right: 24px;

        .name,
        .pname,
        .pnumber,
        .price {
          opacity: 0.4;
          font-size: 14px;
          color: #03102b;
          margin-right: 40px;
          display: inline-block;
          vertical-align: top;
          //   border: 1px solid red;
          //   border-bottom: 1px solid #d9dbdf;
        }
        .pname {
          width: 132px;
          white-space: nowrap;
        }
        .pnumber {
          width: 94px;
          white-space: nowrap;
          // font-family: "sans-serif";
        }
        .name {
          width: 126px;
          margin-right: 0px;
        }
        .price {
          width: 72px;
        }
        .name,
        .pname {
          text-align: left;
        }
        .name {
          // padding-left: 24px;
        }
        .pnumber,
        .price {
          text-align: right;
        }
      }
      .xian {
        width: 100%;
        height: vh(0.5);
        background-color: #ebecee;
        margin: 0 auto;
        margin-top: 12px;
        margin-bottom: 10px;
      }
      .danwei {
        position: absolute;
        left: 24px;
        top: 67px;
        span {
          font-size: 12px;
          color: #83879b;
          text-align: left;
        }
      }
      .boxdata {
        padding-bottom: 10px;
        padding-top: 10px;

        line-height: 22px;
        cursor: pointer;
        .name {
          font-size: 13px;
          color: #03102b;
          opacity: 0.6;
          //   border: 1px solid red;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .pname,
        .pnumber {
          font-size: 14px;
          color: #03102b;
          font-weight: 400;
          opacity: 1;
        }
        .price {
          font-size: 14px;
          color: #4aab3d;
          opacity: 1;
        }
        .creat {
          font-size: 13px;
          color: #03102b;
          font-weight: 400;
          cursor: pointer;
        }
        .creat:hover {
          color: #4aab3d;
          opacity: 1;
        }
      }
      .boxdata:hover {
        background-color: rgba(74, 171, 61, 0.06);
      }
    }
  }
  .tradDeal {
    margin-top: 24px;
    .dealtit {
      padding-left: 24px;
      padding-right: 24px;
      margin-top: 16px;
      .dsicon {
        width: 16px;
        height: 16px;
        margin-left: 2px;
        margin-bottom: 2px;
      }
      .dname,
      .dpname,
      .dpnumber,
      .dprice,
      .dcreat {
        font-size: 14px;
        color: #83879b;
        display: inline-block;
        cursor: pointer;
      }
      .dname {
        text-align: left;
        width: 110px;
      }

      .dpname {
        width: 90px;
      }
      .dpnumber,
      .dprice {
        width: 140px;
      }
      .dcreat {
        width: 56px;
        position: relative;
        opacity: 1;
        white-space: nowrap;
        text-align: center;
        margin-right: 0px;
        span {
          // opacity: 0.4;
          color: #83879b;
        }
        img {
          width: 42px;
          position: absolute;
          left: 6px;
          top: -16px;
        }
      }
    }
    .paiming {
      width: 100%;
      // border: 1px solid red;
      height: 336px;
      overflow-y: hidden;
    }
    .dealtdata {
      line-height: 22px;
      margin-bottom: 20px;
      white-space: nowrap;
      .dname,
      .dpname,
      .dpnumber,
      .dprice {
        font-size: 14px;
        opacity: 1;
        text-align: left;
      }
      .dred {
        color: #fe4d4f;
      }
      .dgreen {
        color: #4aab3d;
      }
      .dname,
      .dpname,
      .dpnumber,
      .dprice {
        color: #03102b;
      }
      .dcreat {
        font-size: 13px;
        color: #03102b;
        font-weight: 400;
        opacity: 0.4;
        cursor: pointer;
      }
      .dcreat:hover {
        color: #4aab3d;
        opacity: 1;
      }
    }
    h3.hzuo {
      //   border: 1px solid red;
      width: 15% !important;
    }
    .hmid {
      float: left;
      width: 180px;
      height: 34px;
      line-height: 26px;
      margin-top: -5px;
      // border: 1px solid red;
      .hselect {
        float: left;
      }
    }
  }
  .lsjrong {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    margin-top: 24px;
    padding-bottom: 24px;
    .lsctent {
      margin-top: 12px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-left: 24px;
      padding-right: 24px;
      .lsmeo {
        width: 270px;
        height: 182px;
        cursor: pointer;
        img {
          width: 270px;
          height: 152px;
        }
        p {
          font-size: 14px;
          line-height: 22px;
          text-align: left;
          margin-top: 8px;
          font-weight: 600;
          color: #03102b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .lsmeo:hover {
        p {
          color: #4aab3d;
        }
      }
    }
  }
  .perfictyNew {
    width: 1200px;
    // border: 1px solid blue;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 24px;
    height: 416px;
    h3 {
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      text-align: left;
    }
    .perficty {
      // width: 568px;
      width: 592px;
      background-color: #fff;
      // padding-left: 24px;
      padding-top: 0px;
      h3 {
        padding-left: 0px;
      }
      .peoples {
        // border: 1px solid red;
        width: 100%;
        display: flex;
        flex-direction: row;
        .pbox {
          width: 33%;
          h4 {
            font-size: 16px;
            font-weight: 100;
            line-height: 24px;
            text-align: left;
            margin-top: 10px;
            font-weight: 600;
            margin-bottom: 12px;
            cursor: pointer;
            span {
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background-color: #4aab3d;
              display: inline-block;
              vertical-align: middle;
              margin-right: 5px;
            }
          }
          ul {
            // border: 1px solid red;
            width: 100%;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            li {
              width: 33%;
              display: block;
              font-size: 14px;
              margin-top: 4px;
              margin-bottom: 8px;
              color: rgba(3, 16, 43, 0.6);
              text-align: left;
              cursor: pointer;
            }
            li:hover {
              color: #4aab3d;
            }
          }
        }
      }
      .hzhuanjia {
        margin-bottom: 5px;
      }
      .hvido {
        margin-top: 20px;
        cursor: pointer;
      }
      .videos {
        width: 100%;
        // border: 1px solid red;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        position: relative;
        h3 {
          position: absolute;
          left: 24px;
          top: 24px;
        }
        // margin-top: 16px;
        .outvido {
          // width: 546px;
          // margin-bottom: 24px;
          width: 100%;
          cursor: pointer;
          .vtv {
            width: 100%;
            height: 326px;
            // border: 1px solid red;
            img {
              width: 100%;
            }
          }
        }
        .vtxt {
          font-size: 14px;
          color: #03102b;
          text-align: left;
          line-height: 45px;
          margin-top: 3px;
        }
      }
    }
    .news {
      width: 544px;
      background-color: #fff;
      padding-left: 24px;
      padding-right: 24px;
      padding-top: 22px;
      .boxheader {
        h3 {
          padding-left: 0px;
          line-height: 26px;
        }
        .trit {
          padding-right: 0px;
        }
      }
      .nlist {
        margin-top: 8px;
        .firstnews {
          display: flex;
          flex-direction: space-between;
          cursor: pointer;
          margin-bottom: 4px;
          .firstleft {
            width: 200px;
            height: 118px;
            margin-right: 16px;
            img {
              width: 200px;
              height: 118px;
            }
          }

          .firstright {
            .rtop {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              h4 {
                font-size: 14px;
                color: #03102b;
                font-weight: 600;
                line-height: 22px;
                text-align: left;
                width: 236px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              span {
                color: #03102b;
                opacity: 0.4;
                font-size: 13px;
              }
            }
            .rbot {
              text-align: left;
              margin-top: 8px;
              p {
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                color: #83879b;
                display: inline-block;
              }
              i {
                font-size: 12px;
                color: #4aab3d;
                margin-left: 10px;
              }
            }
          }
        }

        ul {
          li {
            font-size: 14px;
            text-align: left;
            border-bottom: 0.5px solid #ebecee;
            line-height: 54px;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            div.lileft {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-start;
            }
            b.newbs {
              width: 28px;
              height: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #f24827;
              font-size: 10px;
              font-weight: 600;
              border-radius: 3px;
              border: 1px solid #f24827;
              // padding: 2px;
              // line-height: 12px;
              margin-right: 4px;
            }
            img {
              width: 20px;
              height: 20px;
            }
            .imgdefault {
              display: block;
            }
            .imghover {
              display: none;
            }
            p {
              display: inline-block;
              width: 409px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              vertical-align: middle;
              margin-right: 10px;
            }
            b.newsdate {
              white-space: nowrap;
              color: #b3b7bf;
            }
          }
          li:hover {
            color: #4aab3d;
            .imgdefault {
              display: none;
            }
            .imghover {
              display: block;
            }
          }
          li:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
  .helpsdiv {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 80px;
    bottom: 80px;
    cursor: pointer;
    z-index: 9;
    // border: 1px solid red;
    .helpouter {
      line-height: 0;
      i {
        font-size: 50px;
        color: #4aab3d;
      }
    }
  }
}

.tradeMaket {
  width: 1200px;
  height: 216px;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.45) 0%,
    rgba(255, 255, 255, 0.9) 100%
  );
  // border-radius: 12px 12px 0px 0px;
  border: 1px solid #fff;

  backdrop-filter: blur(24px);
  margin: 416px auto;

  .tradeCenter {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    height: 48px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: rgba(74, 171, 61, 0.2);
    .centerleft {
      ul {
        width: 100%;
        display: flex;
        flex-direction: row;
        li {
          width: 96px;
          font-size: 14px;
          color: #03102b;
          font-weight: 500;
          display: inline-block;
          line-height: 48px;
          cursor: pointer;
        }
        li.active {
          border-bottom: 3px solid #4aab3d;
          font-weight: 600;
        }
        li:hover {
          font-weight: 600;
        }
      }
    }
    .centerright {
      line-height: 48px;
      color: #03102b;
      font-size: 14px;
      padding-right: 24px;
    }
  }

  .tradeData {
    text-align: left;
    padding-right: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .maketleft {
    .mktop,
    .mkbottom {
      white-space: nowrap;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding-top: 13px;
    }
  }
  .mkheng {
    width: 100%;
    height: 1px;
    position: absolute;
    top: 92px;
    background-image: linear-gradient(
      90deg,
      rgba(237, 240, 244, 0) 11%,
      #eef1f5 35%,
      #eef1f5 64%,
      rgba(238, 241, 243, 0) 86%
    );
    // background-size: 200% 100%;
    // background-position: center;
  }
  .mk1 {
    text-align: center;
    display: inline-block;
    margin-left: 24px;
    margin-right: 40px;
    padding-top: 8px;
    .mk1img {
      // border: 1px solid red;
      position: relative;
      width: 48px;
      height: 48px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
      img {
        width: 48px;
        height: 48px;
        animation: moveUpDown 2s infinite ease-in-out;
        position: absolute;
        top: -8px;
        left: 0px;
      }

      @keyframes moveUpDown {
        0%,
        100% {
          transform: translateY(-8); /* 图片初始和结束位置 */
        }
        50% {
          transform: translateY(4px); /* 中间位置 */
        }
      }
    }

    .mk1title {
      display: inline-block;
      vertical-align: middle;
      .mk1up {
        font-size: 12px;
        color: #03102b;
        line-height: 18px;
        margin-top: -4px;
      }
      .mk1down {
        font-size: 20px;

        // line-height: 28px;
        font-weight: 600;
        margin-top: -8px;
        span {
          font-size: 14px;
          color: #83879b;
          font-weight: 400;
          vertical-align: middle;
          width: 85px;
          display: inline-block;
          text-align: left;
        }
        b {
          font-weight: 600;
          vertical-align: middle;
          width: 60px;
          display: inline-block;
          text-align: left;
        }
      }
      .mkdefault {
        color: #03102b;
      }
      .mkgreen {
        color: #4aab3d;
      }
      .mkred {
        color: #f24827;
      }
    }
  }
  .mkdemo {
    min-width: 176px;
    display: inline-block;
    text-align: left;
    // margin-left: 32px;
    vertical-align: top;
    margin-right: 56px;
    span {
      font-size: 14px;
      color: #83879b;
      margin-right: 16px;
    }
    b {
      font-size: 18px;
    }
    b.green {
      color: #4aab3d;
    }
    b.red {
      color: #f24827;
    }
    b.default {
      color: #03102b;
    }
    .uptxt {
      margin-bottom: 8px;
    }
    .upbotom {
      margin-bottom: 0px;
    }
    .uptxt,
    .downtxt {
      line-height: 26px;
    }
  }
  .mksan {
    min-width: 110px;
  }
  .mktopsan {
    margin-right: 0px;
  }
  .mkbottom {
    // .mk1 {
    //   margin-right: 56px;
    // }
    .mkdemo {
      margin-right: 47px;
    }
  }
  .mkliang {
    min-width: 184px;
    span {
      font-size: 14px;
    }
    b {
      font-size: 18px;
      color: #03102b;
    }
    strong {
      font-size: 14px;
      color: #83879b;
      font-weight: 400;
    }
  }
  .mkxian {
    width: 1px;
    height: 40px;
    background-color: #edf3fc;
    display: inline-block;
    vertical-align: top;
    margin-top: 13px;
    margin-left: 40px;
    margin-right: 40px;
    opacity: 0;
  }
  .mksrong {
    width: 106px;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .srtop,
    .srbotom {
      font-size: 14px;
      color: #fff;
    }
    svg {
      width: 20px;
      height: 20px;
      line-height: 34px;
      vertical-align: middle;
      margin-right: 4px;
    }
    .green,
    .blue {
      width: 106px;

      height: 34px;
      font-size: 14px;
      line-height: 34px;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
    .green {
      background-color: #4aab3d;
      // margin-bottom: 24px;
    }
    .blue {
      background-color: #2c73ff;
    }
  }
}
// @media (min-width: 1400px) {
//   .tradContainer {
//     .perfictyNew {
//       .perficty {
//         .pbox {
//           ul {
//             li {
//               font-size: 12px !important;
//             }
//           }
//         }
//         .vtxt {
//           font-size: 12px !important;
//           color: #03102b;
//           text-align: left;
//         }
//       }
//       .news {
//         .nlist {
//           ul {
//             li {
//               font-size: 12px !important;
//             }
//           }
//         }
//       }
//     }
//   }
// }
// @media (min-width: 1600px) {
//   .tradContainer {
//     .perfictyNew {
//       .perficty {
//         .pbox {
//           ul {
//             li {
//               font-size: 14px !important;
//             }
//           }
//         }
//         .vtxt {
//           font-size: 14px !important;
//           color: #03102b;
//           text-align: left;
//         }
//       }
//       .news {
//         .nlist {
//           ul {
//             li {
//               font-size: 14px !important;
//             }
//           }
//         }
//       }
//     }
//   }
// }
</style>
